import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';

export interface UnsavedChangesComponent {
  hasUnsavedChanges(): boolean;
}

export const unsavedChangesGuard: CanDeactivateFn<UnsavedChangesComponent> = (component) => {
  if (!component.hasUnsavedChanges()) return true;
  return window.confirm('You have unsaved changes. Leave without saving?');
};
